
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Font, FontMixin } from '../../mixins/Font';

@Component
export default class Button extends Mixins(FontMixin) {
  @Prop({ default: false }) isGhost!: boolean;
  @Prop({ default: false }) isDark!: boolean;
  @Prop({ default: false }) isBig!: boolean;
  @Prop({ default: false }) isSmall!: boolean;
  @Prop({ default: false }) isTiny!: boolean;
  @Prop({ default: false }) isFullWidth!: boolean;
  @Prop({ default: false }) isDisabled!: boolean;
  @Prop({ default: false }) isText!: boolean;
  @Prop({ default: false }) isRounded!: boolean;
  @Prop({ default: true }) isBold!: boolean;
  @Prop({ default: true }) isClickable!: boolean;
  @Prop() textColor!: string;
  @Prop() backgroundColor!: string;
  @Prop({ default: Font.PT_MONO }) font!: Font;

  get classNames() {
    return {
      'button--ghost': this.isGhost,
      'button--dark': this.isDark,
      'button--big': this.isBig,
      'button--tiny': this.isTiny,
      'button--small': this.isSmall,
      'button--full-width': this.isFullWidth,
      'button--disabled': this.isDisabled,
      'button--text': this.isText,
      'button--rounded': this.isRounded,
      'button--bold': this.isBold,
      'button--clickable': this.isClickable,
    };
  }

  get fontSize() {
    if (this.isBig) {
      return '26px';
    }

    // poppins needs smaller
    return this.font === Font.POPPINS ? '16px' : '18px';
  }

  get lineHeight() {
    return this.isBig ? '25px' : '20px';
  }

  get style() {
    return {
      fontFamily: this.$getFontFamily(this.font),
      fontSize: this.fontSize,
      lineHeight: this.lineHeight,
      background: this.isGhost ? 'transparent' : (this.backgroundColor || undefined),
      borderColor: this.backgroundColor || undefined,
      color: this.textColor || undefined,
    };
  }
}
